import { useDispatch } from "react-redux";
import AlatBeratMain from "../../../features/masters/alat-berat/components/alat-berat-main";
import { setLayoutDashboardTitle } from "../../../store/ui-slice";
import { useEffect } from "react";

const title = "Master Alat Berat";

const AlatBeratMasterPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <AlatBeratMain />;
};

export default AlatBeratMasterPage;
